// Порядок симпатий для ленты кружков (/chats) и страницы «Все» (/sympathies):
// сначала взаимные, затем суперлайки, затем лайки; внутри каждой группы —
// новые первыми. Один пользователь — одна запись (самая новая симпатия).

const TYPE_PRIORITY = { mutual: 0, superlike: 1, like: 2 };

const timeOf = (n) => {
  const t = Date.parse(n?.createdAt);
  return Number.isFinite(t) ? t : 0;
};

const byNovelty = (a, b) => timeOf(b) - timeOf(a);

export function sortSympathyNotifications(notifications) {
  if (!Array.isArray(notifications)) return [];

  const byUser = new Map();

  // Сортируем по новизне и берём первое вхождение пользователя:
  // взаимная создаётся позже лайка/суперлайка, поэтому при дедупликации
  // автоматически побеждает самый свежий (и самый «сильный») тип
  const sorted = notifications.filter(Boolean).sort(byNovelty);
  sorted.forEach((n) => {
    const id = n?.payload?._id || n._id;
    if (!byUser.has(id)) byUser.set(id, n);
  });

  return [...byUser.values()].sort((a, b) => {
    const prioA = TYPE_PRIORITY[a.type] ?? 3;
    const prioB = TYPE_PRIORITY[b.type] ?? 3;
    if (prioA !== prioB) return prioA - prioB;
    return byNovelty(a, b);
  });
}
